import { Helmet } from 'react-helmet-async';

const SITE_NAME    = 'Perkly';
const SITE_URL     = 'https://useperkly.com';
const OG_IMAGE     = 'https://useperkly.com/og-image.png';
const DEFAULT_DESC = 'Discover exclusive student deals on food, cafés, nightlife, fitness and local experiences in Athens, Georgia. Claim nearby offers with Perkly.';

/**
 * SEO — drop in any page to set title, description, OG, Twitter tags.
 *
 * Props
 *   rawTitle   — exact <title> string (use for homepage / pages with custom format)
 *   title      — page name that gets " | Perkly" appended automatically
 *   description — meta description (falls back to DEFAULT_DESC)
 *   canonical   — path string, e.g. "/explore"   (SITE_URL is prepended)
 *   ogImage     — absolute URL for og:image (falls back to OG_IMAGE)
 *   noIndex     — if true, adds noindex,nofollow robots tag
 */
export function SEO({ rawTitle, title, description, canonical, ogImage, noIndex }) {
  const fullTitle   = rawTitle || (title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Student Deals & Local Experiences in Athens, GA`);
  const metaDesc    = description || DEFAULT_DESC;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL;
  const image       = ogImage || OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:type"        content="website" />
      <meta property="og:url"         content={canonicalUrl} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image"       content={image} />
      <meta property="og:image:width"  content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale"      content="en_US" />

      {/* Twitter / X */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image"       content={image} />

      {noIndex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
